import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledSelectFormatItemWrapper = styled.div<{
  $mode: 'default' | 'toggle' | 'readonly';
  $active: boolean;
}>`
  cursor: ${({ $mode }) => ($mode === 'readonly' ? 'default' : 'pointer')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  padding: ${({ theme }) =>
    `${utils.rem(theme.Spacing.Size.XSmall)} ${utils.rem(theme.Spacing.Size.XSmall)} ${utils.rem(
      theme.Spacing.Size.MediumSmall
    )}`};
  user-select: none;
  transition: all ${({ theme }) => theme.Transition.Duration.In}ms ease-in-out;

  ${({ $mode, theme }) =>
    $mode === 'default' &&
    css`
      &:hover {
        background-color: ${theme.Color.Brand.Lightest};
      }
    `}

  ${({ $mode, theme, $active }) =>
    $mode === 'toggle' &&
    $active &&
    css`
      background-color: ${theme.Color.Brand.Lightest};
    `}

  pointer-events: ${({ $mode }) => ($mode === 'readonly' ? 'none' : 'auto')};
`;

export const StyledCenterIconWrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

export const StyledBottomTextWrapper = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  width: 100%;
`;

export const StyledToggleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;
